module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/step2_syndicate-e953c1d543ad004bb60d2b5840212601.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/step2_syndicate.svg
// module id = 1600
// module chunks = 0